<mat-divider class="tab-header"></mat-divider>
<div class="tab-content-container">
    <div>
        <div class="tapestry-body body--sm text-spacing">
            {{
                'seller-tools-panel.prospect-demos.tab-description' | translate
            }}
        </div>
        <div
            class="tapestry-body body--sm text-spacing"
            [innerHTML]="
                'seller-tools-panel.prospect-demos.tab-sub-description'
                    | translate
            "
        ></div>
    </div>
    @if (!showAddProspectDemoField) {
        <tapestry-button
            class="action-btn"
            icon="add"
            [size]="ButtonSize.Small"
            [text]="'platform.oi-links.create-demo-account' | translate"
            (buttonClicked)="showAddProspectDemo()"
            trackingName="createDemoAccountBtn"
        ></tapestry-button>
    }
    @if (showAddProspectDemoField) {
        <form [formGroup]="form" class="workshop-form">
            <div
                class="create-demo-account--content--prospect-company-name-text-control"
            >
                <tapestry-text
                    [label]="
                        'platform.create-demo-account.controls.prospect-name.label'
                            | translate
                    "
                    formControlName="demoAccountName"
                    [control]="form.controls.demoAccountName"
                    trackingName="prospectDemoAccountName"
                ></tapestry-text>
                @if (
                    form.controls.demoAccountName.invalid &&
                    (form.controls.demoAccountName.dirty ||
                        form.controls.demoAccountName.touched)
                ) {
                    <div class="form-error-body tapestry-body body--sm">
                        @if (form.controls.demoAccountName.errors?.required) {
                            {{
                                'platform.create-demo-account.controls.prospect-name.validation.required'
                                    | translate
                            }}
                        }
                        @if (
                            form.controls.demoAccountName.errors
                                ?.duplicateDemoAccountName
                        ) {
                            {{
                                'platform.create-demo-account.controls.prospect-name.validation.duplicate-company-name'
                                    | translate
                            }}
                        }
                    </div>
                }
            </div>
            @if ((form.controls.users.controls | keyvalue).length > 0) {
                <div class="behavioral-assessments-checkbox-group">
                    <div class="tapestry-body body--sm bold">
                        {{
                            'platform.create-demo-account.controls.users.subtitle'
                                | translate
                        }}
                    </div>
                    <div
                        class="behavioral-assessments-checkbox-group--users"
                        formGroupName="users"
                    >
                        @for (
                            control of form.controls.users.controls | keyvalue;
                            track control
                        ) {
                            <tapestry-checkbox
                                [formControlName]="control.key"
                                [label]="
                                    control.key
                                        | demoUserDataDisplayById
                                            : selectedDemoUserData
                                "
                            ></tapestry-checkbox>
                        }
                        @if (
                            form.controls.users.invalid &&
                            (form.controls.users.dirty ||
                                form.controls.users.touched)
                        ) {
                            @if (
                                form.controls.users.errors?.minimumUserSelection
                            ) {
                                <div
                                    class="create-demo-account--form-error-body tapestry-body body--sm"
                                >
                                    {{
                                        'platform.create-demo-account.controls.users.validation.minimum-selection'
                                            | translate
                                    }}
                                </div>
                            }
                        }
                    </div>
                </div>
            }
            <div class="create-demo-account--content--alert-group">
                <tapestry-inline-message-box
                    class="seller-tools-inline-message"
                    [type]="InlineMessageBoxType.Info"
                    [content]="
                        'platform.create-demo-account.alerts.info' | translate
                    "
                >
                </tapestry-inline-message-box>
                <tapestry-inline-message-box
                    class="seller-tools-inline-message"
                    [type]="InlineMessageBoxType.Warning"
                    [content]="
                        'platform.create-demo-account.alerts.warning'
                            | translate
                    "
                ></tapestry-inline-message-box>
            </div>
            <div class="workshop-button-section">
                <tapestry-button
                    [text]="'text.common-terms.cancel' | translate"
                    [color]="ButtonColor.Secondary"
                    [size]="ButtonSize.Small"
                    (buttonClicked)="cancel()"
                ></tapestry-button>
                <tapestry-button
                    [disabled]="form.invalid"
                    [text]="'platform.oi-links.create-demo-account' | translate"
                    [size]="ButtonSize.Small"
                    (buttonClicked)="saveChanges()"
                    trackingName="createDemoAccountBtn"
                ></tapestry-button>
            </div>
        </form>
    }
    <ag-grid-angular
        #prospectDemoAccountsGrid
        class="ag-theme-tapestry-grid seller-tools-grid"
        [columnDefs]="columnDefs"
        [rowData]="prospectDemoAccountData$ | async"
        rowSelection="multiple"
        [suppressRowClickSelection]="true"
        (gridReady)="gridReadyHandler($event)"
        trackingName="prospectDemoAccountsGrid"
    ></ag-grid-angular>
</div>
